import React from 'react';
import {Section, Table, NameCell, ValueCell} from '../components/cells';
import {money, count, percent, squareFeet, rateLabel, pricePsf} from '../model/format';

/**
 * Marketing sheet: a read-only summary. Every figure is pulled from the other tabs, current
 * column only, rows in the workbook's order.
 */


/** Marketing!F6:H23. Expenses arrive in Marketing order (EXPENSE_LINES). */
function incomeRows(calc) {
    const income = calc.income;
    const rates = income.rates;
    return [
        {label: 'Gross Potential Rent', line: income.gross_potential_rent},
        {label: `Less: Physical Vacancy (${rateLabel(rates.vacancy.current)})`, line: income.vacancy},
        {label: `Less: Economic Vacancy (${rateLabel(rates.economic_vacancy.current)}) (NRU, LTL, RC, BD)`, line: income.economic_vacancy},
        {label: 'Other Income - RUBS, Fees, Parking', line: income.other_income},
        {label: 'Effective Gross Income', line: income.effective_gross_income, strong: true},
        {label: 'Operating Expenses', heading: true},
        ...income.expenses.map(e => ({
            label: e.key === 'management_fee' ? `${e.label} (${rateLabel(rates.management_fee.current)})` : e.label,
            line: e,
            indent: true,
        })),
        {label: 'Total Expenses', line: income.total_expenses, strong: true},
        {label: 'NET OPERATING INCOME', line: income.net_operating_income, total: true},
    ];
}

export default function Marketing({inputs, calc}) {
    const current = calc.valuation.current;
    const cityState = [inputs.city, inputs.state].filter(Boolean).join(', ');

    const offering = [
        ['Price', money(current.price)],
        ['Price Per Unit', money(current.price_per_unit)],
        ['PSF', pricePsf(current.psf)],
        ['In Place Cap Rate', percent(current.cap_rate)],
        ['Net Operating Income', money(current.noi)],
        ['Number of Units', count(calc.units)],
        ['Year Built/Renovated', inputs.year_built || '-'],
        ['Lot Size', Number(inputs.lot_size) ? `${Number(inputs.lot_size).toFixed(2)} Acres` : '-'],
    ];
    const overview = [
        ['Total Units', count(calc.units)],
        ['Avg. Unit Size', squareFeet(calc.rentRoll.total.avg_sf)],
        ['Occupancy', percent(calc.rentRoll.occupancy, 0)],
        ['Parking', calc.propertyInfo.parking_per_unit ? `${calc.propertyInfo.parking_per_unit.toFixed(2)}/Unit` : '-'],
        ['Rentable SF', squareFeet(calc.rentableSf)],
    ];

    return (
        <div className='mf-tab mf-marketing'>
            <div className='mf-property-heading'>
                <div className='mf-property-heading__name'>{inputs.name || 'Untitled Property'}</div>
                <div className='mf-property-heading__address'>{[inputs.address, cityState].filter(Boolean).join(' · ')}</div>
            </div>
            <div className='Financials_list_columns'>
                <div className='Financials_list_column mf-column'>
                    <Section title='Offering Summary'>
                        <Table className='mf-kv-table'>
                            {offering.map(([label, value]) => (
                                <tr key={label}><NameCell>{label}</NameCell><ValueCell>{value}</ValueCell></tr>
                            ))}
                        </Table>
                    </Section>
                    <Section title='Asset Overview'>
                        <Table className='mf-kv-table'>
                            {overview.map(([label, value]) => (
                                <tr key={label}><NameCell>{label}</NameCell><ValueCell>{value}</ValueCell></tr>
                            ))}
                        </Table>
                    </Section>
                </div>
                <div className='Financials_list_column mf-column'>
                    <Section title='Income & Expenses'>
                        <Table className='mf-income-table' header={['', 'Annual', 'Per Unit']}>
                            {incomeRows(calc).map(row => row.heading ?
                                <tr key={row.label} className='mf-heading-row'><NameCell>{row.label}</NameCell><ValueCell/><ValueCell/></tr>
                                :
                                <tr key={row.label} className={`${row.strong ? 'mf-strong-row' : ''} ${row.total ? 'mf-total-row' : ''}`}>
                                    <NameCell className={row.indent ? 'mf-indent' : ''}>{row.label}</NameCell>
                                    <ValueCell>{money(row.line.current)}</ValueCell>
                                    <ValueCell>{money(row.line.current_per_unit)}</ValueCell>
                                </tr>
                            )}
                        </Table>
                    </Section>
                </div>
            </div>
        </div>
    );
}
